import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { IconSvg } from '../../atoms'
import { timeFormat } from '../../organisms/duration-from/timeFormat'

interface ITextTravelTimeProps {
  destination?: string | null
  travelTimeInSecondForDriving?: number
  travelTimeInSecondForTransit?: number
}

const MIN_DURATION_IN_SECONDS = 11 * 60

export const TextTravelTime: React.FC<ITextTravelTimeProps> = ({
  destination,
  travelTimeInSecondForDriving = 0,
  travelTimeInSecondForTransit = 0,
}) => {
  if (
    (!travelTimeInSecondForDriving && !travelTimeInSecondForTransit) ||
    typeof destination !== 'string'
  ) {
    return null
  }

  return (
    <div className={s.wrap}>
      <div className={s.wrapDestination}>
        {travelTimeInSecondForDriving < MIN_DURATION_IN_SECONDS ? (
          <FormattedMessage
            id='ui.TextTravelTime.closeDestination'
            defaultMessage='{destination} (centre)'
            values={{ destination }}
          />
        ) : (
          <FormattedMessage
            id='ui.TextTravelTime.from'
            defaultMessage='Depuis {destination}'
            values={{ destination }}
          />
        )}
      </div>
      {travelTimeInSecondForDriving > MIN_DURATION_IN_SECONDS && (
        <>
          {travelTimeInSecondForDriving > 0 && (
            <div className={s.wrapTime}>
              <IconSvg.CarOutline />
              <span>{timeFormat(travelTimeInSecondForDriving)}</span>
            </div>
          )}
          {travelTimeInSecondForTransit > 0 && (
            <div className={s.wrapTime}>
              <IconSvg.TrainOutline />
              <span>{timeFormat(travelTimeInSecondForTransit)}</span>
            </div>
          )}
        </>
      )}
    </div>
  )
}
